// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  outline: 0px;
  margin: 0px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  appearance: none;
  text-decoration: none;
  line-height: 1.75;
  min-width: 64px;
  text-transform: none;
  border-radius: 6px;
  transition: none 0s ease 0s;
  font-weight: 500;
  box-shadow: none;
  padding: 8px 12px;
  color: rgb(255, 255, 255);
  background-color: var(--theme-primary);
  border: 1px solid var(--theme-primary);
  min-height: 28px;
  height: 28px;
  font-size: 12px;
}

.text_300 {
  font-size: 13px;
  line-height: 1.5;
  font-weight: 300;
}

/* MODAL */
/* Background effect. It covers the entire site */
.custom_modal {
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(255, 255, 255, 0.4);
  /* Overlay effect: translucent background: black w/ partial opacity */
  z-index: 1;
  /* Overlay effect: positioned over other containers */
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  position: fixed;
  /* Fix position on the top-left corner*/
  top: 0;
  left: 0;
  overflow: auto;
  /* Enable scroll if needed */
  padding-top: 80px;
  /* Location of the content container */
}

/* Modal content */
.custom_modal-content {
  background-color: #f1f1f1;
  width: 20%;
  /* Width in proportion to its parent container*/
  min-width: 340px;
  /* Max width where it stops expanding */
  max-width: 640px;
  /* Max width where it stops expanding */
  height: 30%;
  /* Height in proportion to its parent container */
  margin: auto;
  /* Auto margin according to the element width */
  padding: 10px;
  border-radius: 20px;
  /* Optional. Rounds container corners */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* flex div */
.custom_modal-flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: -webkit-fill-available;
}

/* static message */
.custom_modal_static-msg,
.custom_modal_dynamic-msg {
  font-family: "Poppins";
}

.custom_modal_static-msg {
  font-size: 13px;
  font-weight: 800;
  margin-top: 1rem;
  text-align: center;
}

/* dynamic message */
.custom_modal_dynamic-msg {
  font-size: 12px;
  font-weight: 600;
  margin-top: 4px;
  color: #757575;
}

/* Close button */
.close {
  color: #aaaaaa;
  float: right;
  /* Positioned to the right of the parent container whichever size it is */
  font-size: 25px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.custom_popper_content {
  width: 340px;
  margin: auto;
  /* Auto margin according to the element width */
  position: absolute;
  transform: translate(-50%, -50%);
  box-shadow: rgba(89, 89, 89, 0.41) 4px 4px 10px 0px;
  border-radius: 6px;
  background-color: rgb(255, 255, 255);
}

.custom_popper_header {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 0.5px solid rgb(243, 243, 243);
}
.custom_popper_header__title {
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  line-height: normal;
  padding: 2px 0px;
}
.custom_popper_header__searchbox {
  height: 30px;
  border: 1px solid rgb(175, 175, 175);
  font-size: 12px;
  min-height: 30px;
  border-radius: 20px;
  padding: 0px 4px;
  background: rgb(255, 255, 255);
}
.custom_popper_header__searchbox:hover, .custom_popper_header__searchbox:focus, .custom_popper_header__searchbox:active {
  border: 1px solid rgb(25, 118, 210);
}
.custom_popper_header .MuiGrid-item {
  padding-bottom: 0 !important;
}

.custom_popper_close {
  text-align: right;
}

.custom_popper_task-tab .MuiTabScrollButton-root {
  width: 1rem;
}
@media (min-width: 599px) {
  .custom_popper_task-tab .MuiTab-root {
    min-width: 7rem;
  }
}

.custom_popper_taskmenu {
  margin-top: 8px;
  height: 36vh;
  overflow: hidden scroll;
  border-radius: 0px 0px 6px 6px;
}

.custom_popper_taskmenu-task {
  min-height: 45px;
  border-bottom: 0.5px solid rgb(243, 243, 243);
  display: flex;
  padding: 12px;
  align-items: center;
  cursor: pointer;
}
.custom_popper_taskmenu-task__element_name {
  color: #060606;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.28px;
  font-family: "Poppins", sans-serif;
}
.custom_popper_taskmenu-task:hover, .custom_popper_taskmenu-task:focus, .custom_popper_taskmenu-task:active {
  background: rgb(202, 224, 245);
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.cursor-pointer {
  cursor: pointer;
}

.gutter-horizontal {
  background: rgba(45, 45, 45, 0.05);
  width: 10px;
  resize: horizontal;
  cursor: col-resize;
}

.gutter-horizontal :hover {
  background-color: rgba(45, 45, 45, 0.3);
}

.workflow-action-btns {
  justify-content: space-between;
  align-items: center;
}
.workflow-action-btns .MuiIconButton-root {
  padding: 5px 10px;
}
.workflow-action-btns .MuiIconButton-root:hover {
  background-color: transparent;
}
.workflow-action-btns .run-icon .MuiSvgIcon-root {
  width: 24px;
  height: 24px;
}
.workflow-action-btns .primary {
  color: var(--theme-primary);
}
.workflow-action-btns .warn {
  color: red;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.space-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.gap-1 {
  gap: 1rem;
}

.full-width {
  width: 100%;
}

.warn-bg {
  background-color: red !important;
}

.raised-btn {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  border-radius: 4px !important;
  background-color: #ffffff !important;
  padding: 0.5rem !important;
  align-self: center;
  margin: 0.5rem 0.3rem !important;
  height: 32px;
  width: 32px;
  line-height: 32px;
}

.mandatory {
  color: #e50914;
}`, "",{"version":3,"sources":["webpack://./src/components/componentStyles/common.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EAIA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAMA,UAAA;AACA,iDAAA;AACA;EACE,8BAAA;EACA,mBAAA;EACA,0CAAA;EAIA,qEAAA;EACA,UAAA;EACA,qDAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,4BAAA;EACA,iBAAA;EACA,sCAAA;AANF;;AASA,kBAAA;AACA;EACE,yBAAA;EAEA,UAAA;EACA,+CAAA;EACA,gBAAA;EACA,uCAAA;EACA,gBAAA;EACA,uCAAA;EACA,WAAA;EACA,iDAAA;EACA,YAAA;EACA,+CAAA;EACA,aAAA;EAEA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AARF;;AAWA,aAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;AARF;;AAWA,mBAAA;AACA;;EAEE,sBAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AARF;;AAWA,oBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AARF;;AAWA,iBAAA;AACA;EACE,cAAA;EACA,YAAA;EACA,yEAAA;EACA,eAAA;EACA,iBAAA;AARF;;AAWA;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AARF;;AAwBA;EACE,YAAA;EACA,YAAA;EACA,+CAAA;EACA,kBAAA;EACA,gCAAA;EACA,mDAAA;EACA,kBAAA;EACA,oCAAA;AArBF;;AAyBA;EACE,aAAA;EAEA,mBAAA;EACA,aAAA;EACA,6CAAA;AAtBF;AAwBE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAtBJ;AAyBE;EACE,YAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AAvBJ;AAyBI;EAGE,mCAAA;AAzBN;AA6BE;EACE,4BAAA;AA3BJ;;AA+BA;EACE,iBAAA;AA5BF;;AAgCE;EACE,WAAA;AA7BJ;AAgCE;EACE;IACE,eAAA;EA9BJ;AACF;;AAkCA;EACE,eAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;AA/BF;;AAkCA;EACE,gBAAA;EACA,6CAAA;EACA,aAAA;EACA,aAAA;EAEA,mBAAA;EACA,eAAA;AA/BF;AAiCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kCAAA;AA/BJ;AAkCE;EAGE,8BAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,mBAAA;AAnCF;;AAsCA;EACE,eAAA;AAnCF;;AAsCA;EACE,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAnCF;;AAsCA;EACE,uCAAA;AAnCF;;AAsCA;EACE,8BAAA;EACA,mBAAA;AAnCF;AAqCE;EACE,iBAAA;AAnCJ;AAsCE;EACE,6BAAA;AApCJ;AAuCE;EACE,WAAA;EACA,YAAA;AArCJ;AAwCE;EACE,2BAAA;AAtCJ;AAyCE;EACE,UAAA;AAvCJ;;AA4CA;EACE,aAAA;EACA,mBAAA;AAzCF;;AA4CA;EACE,8BAAA;AAzCF;;AA4CA;EACE,mBAAA;AAzCF;;AA4CA;EACE,SAAA;AAzCF;;AA4CA;EACE,WAAA;AAzCF;;AA4CA;EACE,gCAAA;AAzCF;;AA4CA;EACE,oIAAA;EACA,6BAAA;EACA,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAzCF;;AA4CA;EACE,cAAA;AAzCF","sourcesContent":[".btn {\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  position: relative;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n  outline: 0px;\n  margin: 0px;\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n  appearance: none;\n  text-decoration: none;\n  //   font-family: Lexend, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n  //     Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\n  //     \"Segoe UI Symbol\";\n  line-height: 1.75;\n  min-width: 64px;\n  text-transform: none;\n  border-radius: 6px;\n  transition: none 0s ease 0s;\n  font-weight: 500;\n  box-shadow: none;\n  padding: 8px 12px;\n  color: rgb(255, 255, 255);\n  background-color: var(--theme-primary);\n  border: 1px solid var(--theme-primary);;\n  min-height: 28px;\n  height: 28px;\n  font-size: 12px;\n}\n\n.text_300 {\n  font-size: 13px;\n  line-height: 1.5;\n  font-weight: 300;\n}\n\n// modal loader styles\n/* MODAL */\n/* Background effect. It covers the entire site */\n.custom_modal {\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(255,\n      255,\n      255,\n      0.4);\n  /* Overlay effect: translucent background: black w/ partial opacity */\n  z-index: 1;\n  /* Overlay effect: positioned over other containers */\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  position: fixed;\n  /* Fix position on the top-left corner*/\n  top: 0;\n  left: 0;\n  overflow: auto;\n  /* Enable scroll if needed */\n  padding-top: 80px;\n  /* Location of the content container */\n}\n\n/* Modal content */\n.custom_modal-content {\n  background-color: #f1f1f1;\n  // width: 70%; /* Width in proportion to its parent container*/\n  width: 20%;\n  /* Width in proportion to its parent container*/\n  min-width: 340px;\n  /* Max width where it stops expanding */\n  max-width: 640px;\n  /* Max width where it stops expanding */\n  height: 30%;\n  /* Height in proportion to its parent container */\n  margin: auto;\n  /* Auto margin according to the element width */\n  padding: 10px;\n  // border: 1px solid black;\n  border-radius: 20px;\n  /* Optional. Rounds container corners */\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* flex div */\n.custom_modal-flex {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: -webkit-fill-available;\n}\n\n/* static message */\n.custom_modal_static-msg,\n.custom_modal_dynamic-msg {\n  font-family: \"Poppins\";\n}\n\n.custom_modal_static-msg {\n  font-size: 13px;\n  font-weight: 800;\n  margin-top: 1rem;\n  text-align: center;\n}\n\n/* dynamic message */\n.custom_modal_dynamic-msg {\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 4px;\n  color: #757575;\n}\n\n/* Close button */\n.close {\n  color: #aaaaaa;\n  float: right;\n  /* Positioned to the right of the parent container whichever size it is */\n  font-size: 25px;\n  font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n// task popper\n// .custom_popper_content {\n//   width: 340px;\n//   margin: auto; /* Auto margin according to the element width */\n//   position: absolute;\n//   top: 50%;\n//   left: 50%;\n//   transform: translate(-50%, -50%);\n//   box-shadow: rgba(89, 89, 89, 0.41) 4px 4px 10px 0px;\n//   border-radius: 6px;\n//   background-color: rgb(255, 255, 255);\n// }\n\n.custom_popper_content {\n  width: 340px;\n  margin: auto;\n  /* Auto margin according to the element width */\n  position: absolute;\n  transform: translate(-50%, -50%);\n  box-shadow: rgba(89, 89, 89, 0.41) 4px 4px 10px 0px;\n  border-radius: 6px;\n  background-color: rgb(255, 255, 255);\n}\n\n\n.custom_popper_header {\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 0.5px solid rgb(243, 243, 243);\n\n  &__title {\n    font-size: 15px;\n    font-weight: 600;\n    text-transform: uppercase;\n    line-height: normal;\n    padding: 2px 0px;\n  }\n\n  &__searchbox {\n    height: 30px;\n    border: 1px solid rgb(175, 175, 175);\n    font-size: 12px;\n    min-height: 30px;\n    border-radius: 20px;\n    padding: 0px 4px;\n    background: rgb(255, 255, 255);\n\n    &:hover,\n    &:focus,\n    &:active {\n      border: 1px solid rgb(25, 118, 210);\n    }\n  }\n\n  .MuiGrid-item {\n    padding-bottom: 0 !important;\n  }\n}\n\n.custom_popper_close {\n  text-align: right;\n}\n\n.custom_popper_task-tab {\n  .MuiTabScrollButton-root {\n    width: 1rem;\n  }\n\n  @media (min-width: 599px) {\n    .MuiTab-root {\n      min-width: 7rem;\n    }\n  }\n}\n\n.custom_popper_taskmenu {\n  margin-top: 8px;\n  height: 36vh;\n  overflow: hidden scroll;\n  border-radius: 0px 0px 6px 6px;\n}\n\n.custom_popper_taskmenu-task {\n  min-height: 45px;\n  border-bottom: 0.5px solid rgb(243, 243, 243);\n  display: flex;\n  padding: 12px;\n  -webkit-box-align: center;\n  align-items: center;\n  cursor: pointer;\n\n  &__element_name {\n    color: #060606;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: -0.28px;\n    font-family: \"Poppins\", sans-serif;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: rgb(202, 224, 245);\n  }\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.cursor-pointer{\n  cursor: pointer;\n}\n\n.gutter-horizontal {\n  background: rgba(45, 45, 45, 0.05);\n  width: 10px;\n  resize: horizontal;\n  cursor: col-resize;\n}\n\n.gutter-horizontal :hover {\n  background-color: rgb(45, 45, 45, 0.3);\n}\n\n.workflow-action-btns{\n  justify-content: space-between;\n  align-items: center;\n\n  .MuiIconButton-root{\n    padding: 5px 10px;\n  }\n\n  .MuiIconButton-root:hover{\n    background-color: transparent;\n  }\n\n  .run-icon .MuiSvgIcon-root{\n    width: 24px;\n    height: 24px;\n  }\n\n  .primary{\n    color: var(--theme-primary);\n  }\n\n  .warn{\n    color: red;\n  }\n}\n\n// className=\"flex-row space-between align-items-center\"\n.flex-row{\n  display: flex;\n  flex-direction: row;\n}\n\n.space-between{\n  justify-content: space-between;\n}\n\n.align-items-center{\n  align-items: center;\n}\n\n.gap-1{\n  gap: 1rem;\n}\n\n.full-width{\n  width: 100%;\n}\n\n.warn-bg{\n  background-color: red !important;\n}\n\n.raised-btn{\n  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;\n  border-radius: 4px !important;\n  background-color: #ffffff !important;\n  padding: 0.5rem !important;\n  align-self: center;\n  margin: 0.5rem 0.3rem !important;\n  height: 32px;\n  width: 32px;\n  line-height: 32px;\n}\n\n.mandatory{\n  color: #e50914;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
